import Money from '../shared/Money'
import PriceConfigurationJson from './interfaces/PriceConfigurationJson'
import PriceItem from 'src/models/pricing/PriceItem'

export default class PriceConfiguration {
  pricingTable: Array<PriceItem>

  constructor(pricingTable: Array<PriceItem>) {
    this.pricingTable = pricingTable
  }

  getPriceForLockerTypeAndPeriod(
    lockerTypeId: string,
    periodIdentifier: string,
  ): Money | null {
    for (const priceItem of this.pricingTable) {
      if (
        priceItem.lockerTypeId === lockerTypeId &&
        periodIdentifier === priceItem.periodIdentifier
      ) {
        return priceItem.price
      }
    }

    return null
  }

  static fromJson(data: PriceConfigurationJson) {
    return new this(data.pricingTable.map((item) => PriceItem.fromJson(item)))
  }
}
